export enum HandStatus {
	Open,
	Closed,
	Riichi
}
